export async function updateBeneficiaries(beneficiariesRepository, beneficiaries) {
  return beneficiariesRepository.update(beneficiaries);
};

